import { useState, useEffect } from 'react';
import { array, func, object } from 'prop-types';
import { AddIcon, DeleteIcon } from 'components/icons';
import MenuTooltip from './MenuTooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import sty from '../styles/Tabs.module.css';
import { Tab } from '../const';

/**
 * @component TabHeader
 * @param { Object } props
 * @param { array } props.options
 * @param { object } props.isDisabled
 * @param { array } props.chosenOptions
 * @param { function } props.onOptions
 * @param { function } props.onAdd
 * @param { function } props.onDelete
 * @returns { JSX.Element }
 */
function TabHeader(props) {
	const [values, setValues] = useState([]);

	useEffect(() => {
		setValues(props.selected);
	}, [props.selected]);

	return (
		<section className={sty.tab_header_section}>
			<Autocomplete
				multiple
				fullWidth
				disableCloseOnSelect
				value={values}
				options={props.options}
				getOptionLabel={(option) => option[Tab.Name]}
				isOptionEqualToValue={(option, value) => option[Tab.Name] === value[Tab.Name]}
				onChange={(e, newValues) => props.onOptions(newValues)}
				renderOption={(props, option) => {
					return (
						<li {...props} key={option[Tab.Id]}>
							{option.name}
						</li>
					);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Tabs"
						variant="outlined"
						size="small"
						InputLabelProps={{ shrink: true }}
					/>
				)}
			/>
			<div className={sty.tab_header_tooltips}>
				<MenuTooltip
					title="Add Tab(s)"
					disabledTitle="Select Tabs"
					disabled={props.isDisabled.add}
					onClick={props.onAdd}
					icon={<AddIcon />}
				/>
				<MenuTooltip
					title="Delete Tab(s)"
					disabledTitle="Select Checkbox"
					disabled={props.isDisabled.delete}
					onClick={props.onDelete}
					icon={<DeleteIcon />}
				/>
			</div>
		</section>
	);
}

TabHeader.propTypes = {
	options: array,
	isDisabled: object,
	chosenOptions: array,
	onOptions: func,
	onAdd: func,
	onDelete: func,
};

export default TabHeader;
